import React from "react";
import LandingNav from "./components/LandingNav";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import StatsSection from "./components/StatsSection";
import FleetInvestmentSection from "./components/FleetInvestmentSection";
import AppDownloadSection from "./components/AppDownloadSection";
import FooterSection from "./components/FooterSection";

const OnTheGoLandingPage = () => {
  return (
    <div className="min-h-screen" style={{ fontFamily: "'DM Sans', sans-serif", background: "#0a1628" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;0,9..40,800;0,9..40,900;1,9..40,400&display=swap');
        
        html { scroll-behavior: smooth; }
        * { box-sizing: border-box; }

        ::-webkit-scrollbar { width: 6px; }
        ::-webkit-scrollbar-track { background: #0a1628; }
        ::-webkit-scrollbar-thumb { background: rgba(255,215,0,0.3); border-radius: 3px; }
        ::-webkit-scrollbar-thumb:hover { background: rgba(255,215,0,0.5); }
      `}</style>

      <LandingNav />
      <HeroSection />
      <ServicesSection />
      <HowItWorksSection />
      <StatsSection />
      <FleetInvestmentSection />
      <AppDownloadSection />
      <FooterSection />
    </div>
  );
};

export default OnTheGoLandingPage;
